import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faShoppingCart, 
  faPlus, 
  faMinus, 
  faTrash,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import { useCart } from '../contexts/CartContext';

const CartModal = () => {
  const navigate = useNavigate();
  const { 
    cartItems, 
    isCartOpen, 
    setIsCartOpen, 
    addToCart, 
    removeFromCart, 
    getCartTotal 
  } = useCart();

  if (!isCartOpen) return null;

  return (
    <>
      {/* Cart Modal */}
      <div className="fixed inset-y-0 right-0 z-50 w-full sm:w-96 bg-white shadow-2xl transform transition-transform duration-300 overflow-y-auto">
        <div className="flex flex-col h-full">
          {/* Cart Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-200 bg-white">
            <div className="flex items-center space-x-3">
              <FontAwesomeIcon icon={faShoppingCart} className="w-6 h-6 text-black" />
              <h2 className="font-sans text-2xl font-bold text-black">Tu Carrito</h2>
            </div>
            <button
              onClick={() => setIsCartOpen(false)}
              className="p-2 hover:bg-gray-100 rounded-xl transition-colors"
            >
              <FontAwesomeIcon icon={faTimes} className="w-5 h-5 text-gray-600" />
            </button>
          </div>

          {/* Cart Items */}
          <div className="flex-1 overflow-y-auto">
            {cartItems.length === 0 ? (
              <div className="flex flex-col items-center justify-center h-full text-center p-8">
                <FontAwesomeIcon icon={faShoppingCart} className="w-16 h-16 text-gray-300 mb-4" />
                <h3 className="font-sans text-xl font-semibold text-gray-600 mb-2">Tu carrito está vacío</h3>
                <p className="text-gray-500 mb-6">Agrega algunos deliciosos platos para comenzar</p>
                <button
                  onClick={() => {
                    setIsCartOpen(false);
                    navigate('/menu');
                  }}
                  className="bg-black hover:bg-gray-800 text-white py-3 px-6 rounded-xl font-semibold transition-colors"
                >
                  Ver Menú
                </button>
              </div>
            ) : (
              <div className="p-6 space-y-4">
                {cartItems.map((item) => (
                  <div key={item.id} className="flex items-center space-x-4 bg-gray-50 rounded-xl p-4">
                    <div className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0">
                      <img 
                        src={item.image} 
                        alt={item.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-sans font-semibold text-gray-900 truncate">{item.name}</h3>
                      <p className="font-sans text-sm text-gray-600">${item.price.toLocaleString()} c/u</p>
                      <p className="font-sans font-bold text-black">${(item.price * item.quantity).toLocaleString()}</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <button
                        onClick={() => removeFromCart(item.id)}
                        className="p-2 hover:bg-red-50 rounded-xl transition-colors text-red-500 hover:text-red-700"
                      >
                        <FontAwesomeIcon icon={faMinus} className="w-4 h-4" />
                      </button>
                      <span className="w-8 text-center font-bold text-gray-800">{item.quantity}</span>
                      <button
                        onClick={() => addToCart(item)}
                        className="p-2 hover:bg-gray-100 rounded-xl transition-colors text-black hover:text-gray-800"
                      >
                        <FontAwesomeIcon icon={faPlus} className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Cart Footer */}
          {cartItems.length > 0 && (
            <div className="p-6 border-t border-gray-200 bg-white/80 backdrop-blur-sm">
              <div className="flex items-center justify-between mb-6">
                <span className="font-sans text-xl font-bold text-gray-800">Total:</span>
                <span className="font-bold text-3xl text-black">
                  ${getCartTotal().toLocaleString()}
                </span>
              </div>
              <button 
                className="w-full bg-black hover:bg-gray-800 text-white py-4 px-6 rounded-xl font-bold text-lg transition-all duration-300 hover:shadow-lg flex items-center justify-center space-x-3"
                onClick={() => {
                  setIsCartOpen(false);
                  navigate('/order-checkout', { state: { cartItems } });
                }}
              >
                <FontAwesomeIcon icon={faShoppingCart} className="w-5 h-5" />
                <span>PROCEDER AL CHECKOUT</span>
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Cart Overlay */}
      <div 
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40"
        onClick={() => setIsCartOpen(false)}
      />
    </>
  );
};

export default CartModal;